// hinduEventDescriptions.js
// Single source of truth for festival / vrat detail pages

const HinduEventDescriptions = {

  /* -------------------- JANUARY -------------------- */

  "Pradosh Vrat":
    "Pradosh Vrat is observed on the Trayodashi, the 13th day of the lunar fortnight, and is dedicated to Lord Shiva and Goddess Parvati. Devotees observe fasting and special prayers during the Pradosh Kaal, the sacred evening twilight period. Worship performed at this time is believed to remove accumulated sins, resolve long-standing problems, and bring peace, prosperity, and spiritual progress in life.",

  "Paush Purnima":
    "Paush Purnima marks the full moon day of the Paush month and is considered highly auspicious in Hindu tradition. Devotees take holy baths in sacred rivers and engage in charity, donations, and spiritual observances. Acts of generosity performed on this day are believed to bring long-lasting religious merit and inner purification.",

  "Shakambhari Purnima":
    "Shakambhari Purnima honors Goddess Shakambhari, a nourishing form of Goddess Durga associated with vegetation and food. According to tradition, she protected humanity during famine by providing fruits, grains, and herbs. Devotees worship her to seek abundance, prosperity, and protection from natural calamities.",

  "Sakat Chauth":
    "Sakat Chauth is mainly observed by mothers for the health, protection, and long life of their children. The fast is dedicated to Lord Ganesha and is observed throughout the day. Devotees break the fast after moonrise and believe the vrat protects children from misfortune and negative influences.",

  "Sankashti Chaturthi":
    "Sankashti Chaturthi is a monthly fast dedicated to Lord Ganesha and observed during the waning phase of the moon. Devotees fast until moonrise and offer prayers seeking relief from difficulties. The vrat is believed to remove obstacles, bring mental peace, and support success in personal and professional life.",

  "Shattila Ekadashi":
    "Shattila Ekadashi is observed during the Magha month and involves rituals using sesame seeds in various forms. Devotees believe sesame offerings help cleanse sins and purify the soul. Observing this Ekadashi is said to promote spiritual growth and inner discipline.",

  "Makara Sankranti":
    "Makara Sankranti is a major solar festival marking the Sun’s transition into the zodiac sign Capricorn. It signifies the end of winter and the beginning of longer days. The festival is celebrated with charity, kite flying, and preparation of sesame-based sweets, symbolizing warmth and unity.",

  "Mauni Amavasya":
    "Mauni Amavasya is considered a deeply spiritual new moon day focused on silence and self-discipline. Devotees observe silence, meditate, and take holy baths in sacred rivers. These practices are believed to purify the mind, calm the senses, and lead to spiritual awakening.",

  "Magha Amavasya":
    "Magha Amavasya is dedicated to ancestral worship and spiritual cleansing. Devotees perform rituals to honor their ancestors and seek peace for departed souls. The observance is believed to bring blessings, harmony, and protection to the family.",

  "Gupta Navratri Begins":
    "Gupta Navratri marks the beginning of a nine-day period of secret and intense worship of Goddess Durga. It is mainly observed by spiritual practitioners and devotees seeking inner strength. The period emphasizes discipline, devotion, and deep spiritual practices.",

  "Chandra Darshan":
    "Chandra Darshan marks the first sighting of the moon after Amavasya. It is considered an auspicious moment symbolizing new beginnings and positivity. Devotees offer prayers upon seeing the moon to invite good fortune and peace.",

  "Vasant Panchami":
    "Vasant Panchami celebrates the arrival of spring and is dedicated to Goddess Saraswati. Students, scholars, and artists worship her for wisdom, creativity, and success in learning. The color yellow is prominently associated with the festival, symbolizing energy and prosperity.",

  "Ratha Saptami":
    "Ratha Saptami is dedicated to the Sun God and symbolizes his cosmic journey in a chariot. Devotees perform rituals seeking good health and vitality. The day is believed to help overcome illness and negative planetary influences.",

  "Bhishma Ashtami":
    "Bhishma Ashtami commemorates Bhishma Pitamah from the Mahabharata. Devotees perform ancestral rituals and remember his life of duty, sacrifice, and righteousness. The day emphasizes respect for elders and moral values.",

  "Jaya Ekadashi":
    "Jaya Ekadashi is dedicated to Lord Vishnu and observed for spiritual purification. Devotees believe the vrat helps overcome inner weaknesses and negative influences. It is also associated with victory over ignorance and sin.",

  /* -------------------- FEBRUARY -------------------- */

  "Magha Purnima":
    "Magha Purnima is an auspicious full moon day known for charity and sacred bathing. Devotees conclude important religious vows on this day. Acts of generosity performed are believed to bring spiritual fulfillment and blessings.",

  "Guru Ravidas Jayanti":
    "Guru Ravidas Jayanti celebrates the birth of Saint Ravidas, a respected spiritual leader and social reformer. His teachings emphasized equality, devotion, and unity. The day inspires compassion and social harmony.",

  "Vijaya Ekadashi":
    "Vijaya Ekadashi symbolizes victory and success through righteousness. Devotees observe fasting and prayer seeking strength to overcome challenges. The vrat is believed to grant success in positive endeavors.",

  "Maha Shivaratri":
    "Maha Shivaratri is one of the most sacred festivals dedicated to Lord Shiva. Devotees observe fasting, chant mantras, and perform night-long worship. The festival symbolizes spiritual awakening and inner transformation.",

  "Phalguna Amavasya":
    "Phalguna Amavasya is important for ancestral worship and inner purification. Devotees perform rituals to honor departed souls. The observance prepares the mind and spirit for the upcoming Holi festival.",

  "Phulera Dooj":
    "Phulera Dooj marks the beginning of Holi celebrations. It is associated with joy, devotion, and the playful spirit of Lord Krishna. The festival sets a festive and cheerful mood.",

  "Amalaki Ekadashi":
    "Amalaki Ekadashi is dedicated to Lord Vishnu and the sacred Amla tree. Devotees worship the tree for health and longevity. The vrat is believed to purify the body and soul.",

  /* -------------------- MARCH -------------------- */

  "Holika Dahan":
    "Holika Dahan symbolizes the victory of good over evil. Bonfires are lit to commemorate Prahlad’s devotion and the defeat of negative forces. The ritual encourages letting go of ego and harmful tendencies.",

  "Phalguna Purnima":
    "Phalguna Purnima marks the full moon associated with Holi. It represents joy, celebration, and spiritual completeness. The day brings communities together in harmony.",

  "Bhai Dooj":
    "Bhai Dooj celebrates the loving bond between brothers and sisters. Sisters perform rituals and pray for their brothers’ well-being. Brothers offer gifts and promise lifelong support.",

  "Ranga Panchami":
    "Ranga Panchami continues Holi celebrations with vibrant colors. It symbolizes joy, social harmony, and unity. The festival strengthens community bonds.",

  "Sheetala Saptami":
    "Sheetala Saptami is dedicated to Goddess Sheetala, the protector from diseases. Devotees seek health and well-being for their families. Traditional food practices are followed on this day.",

  "Sheetala Ashtami":
    "Sheetala Ashtami focuses on protection from illness and epidemics. Devotees worship Goddess Sheetala with devotion and faith. The observance emphasizes hygiene and health awareness.",

  "Papmochani Ekadashi":
    "Papmochani Ekadashi is observed to cleanse sins and negative karma. Devotees fast and pray for spiritual upliftment. The vrat promotes self-control and devotion.",

  "Chaitra Amavasya":
    "Chaitra Amavasya is significant for ancestral rites and remembrance. Devotees offer prayers for peace of departed souls. It also marks the conclusion of the lunar year.",

  "Chaitra Navratri Begins":
    "Chaitra Navratri marks the Hindu New Year in many regions. Devotees worship nine forms of Goddess Durga over nine days. The festival symbolizes renewal, strength, and devotion.",

  "Gudi Padwa / Ugadi":
    "Gudi Padwa and Ugadi celebrate the Hindu New Year. The festival symbolizes prosperity, renewal, and optimism. Homes are decorated and special dishes are prepared.",

  "Rama Navami":
    "Rama Navami celebrates the birth of Lord Rama. Devotees reflect on his ideals of truth, duty, and righteousness. The festival inspires moral living and devotion.",

  "Kamada Ekadashi":
    "Kamada Ekadashi is believed to fulfill righteous desires. Devotees observe fasting and prayers to Lord Vishnu. The vrat promotes spiritual purity and discipline.",

  /* -------------------- APRIL -------------------- */

  "Chaitra Purnima":
    "Chaitra Purnima is a sacred full moon day for devotion and charity. Devotees engage in prayer and spiritual reflection. The day promotes inner peace and gratitude.",

  "Hanuman Jayanti":
    "Hanuman Jayanti celebrates the birth of Lord Hanuman. He symbolizes strength, devotion, and selfless service. Devotees seek courage and protection through his worship.",

  "Varuthini Ekadashi":
    "Varuthini Ekadashi protects devotees from misfortune. Observing the vrat is believed to bring prosperity and spiritual strength. It encourages discipline and faith.",

  "Akshaya Tritiya":
    "Akshaya Tritiya is considered extremely auspicious for new beginnings. Investments and charitable deeds made on this day are believed to yield lasting benefits. The festival symbolizes eternal prosperity.",

  "Ganga Saptami":
    "Ganga Saptami commemorates the descent of the sacred River Ganga. Devotees perform river worship and purification rituals. The day emphasizes reverence for nature.",

  "Sita Navami":
    "Sita Navami celebrates the birth of Goddess Sita. She represents purity, devotion, and resilience. The festival honors feminine strength and virtue.",

  "Mohini Ekadashi":
    "Mohini Ekadashi commemorates Lord Vishnu’s Mohini avatar. Devotees seek spiritual growth and clarity. The vrat promotes devotion and self-control.",

  /* -------------------- NOVEMBER -------------------- */

  "Govatsa Dwadashi":
    "Govatsa Dwadashi involves worship of cows and calves. It symbolizes gratitude, nourishment, and prosperity. Devotees express respect for nature and life.",

  "Dhanteras":
    "Dhanteras marks the beginning of Diwali celebrations. It is associated with wealth, health, and prosperity. Purchasing valuables and performing prayers are common practices.",

  "Kali Chaudas":
    "Kali Chaudas is observed to ward off negative energies. Devotees perform protective rituals and prayers. The day emphasizes spiritual cleansing.",

  "Diwali / Lakshmi Puja":
    "Diwali celebrates the victory of light over darkness. Lakshmi Puja is performed to invite prosperity and abundance. The festival strengthens family bonds and joy.",

  "Govardhan Puja":
    "Govardhan Puja commemorates Lord Krishna lifting Mount Govardhan. The festival symbolizes devotion and divine protection. Devotees express gratitude for nature’s blessings.",

  "Chhath Puja":
    "Chhath Puja is dedicated to the Sun God. Devotees observe strict fasting and offer prayers at sunrise and sunset. The festival promotes discipline, gratitude, and purity.",

  /* -------------------- DECEMBER -------------------- */

  "Utpanna Ekadashi":
    "Utpanna Ekadashi marks the manifestation of Ekadashi Devi. Devotees observe fasting and worship Lord Vishnu. The day emphasizes spiritual discipline.",

  "Margashirsha Amavasya":
    "Margashirsha Amavasya is significant for ancestral rituals. Devotees perform prayers for peace and purification. The observance encourages reflection and devotion.",

  "Gita Jayanti":
    "Gita Jayanti celebrates the revelation of the Bhagavad Gita. The teachings emphasize duty, devotion, and selfless action. The day inspires spiritual wisdom.",

  "Dattatreya Jayanti":
    "Dattatreya Jayanti marks the birth of Lord Dattatreya. He represents the trinity of Brahma, Vishnu, and Shiva. The festival symbolizes spiritual unity and knowledge."
};

module.exports = HinduEventDescriptions;

